import type { UnitType } from "./types";

/** API 员工状态 Tag 颜色（列表） */
export const EMPLOYEE_STATUS_API_COLORS: Record<string, string> = {
  ACTIVE: "success",
  PROBATION: "processing",
  ON_LEAVE: "warning",
  RESIGNED: "error",
  PENDING_WORK_INFO: "default",
};

/** 单位类型 Tag 配置 */
export const UNIT_TYPE_CONFIG: Record<UnitType, { label: string; color: string }> = {
  agent: { label: "代理", color: "blue" },
  store: { label: "门店", color: "green" },
  supplier: { label: "供应商", color: "orange" },
};
